import reducer from './reducers';

export { default as chatsOperations } from './operations';
export { default as chatsSelectors } from './selectors';

export default reducer;
